import styled from 'styled-components';

export const Wrapper = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 18px;
  border-radius: 8px;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.white};
  box-sizing: border-box;
  transition: outline-width 100ms;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 3px 0px;
`;
